import script from "./NetworkNotSupported.vue?vue&type=script&lang=ts&setup=true"
export * from "./NetworkNotSupported.vue?vue&type=script&lang=ts&setup=true"

import "./NetworkNotSupported.vue?vue&type=style&index=0&id=360fd6fa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360fd6fa"]])

export default __exports__